import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../scripts/axios';

Vue.use(Vuex);

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default new Vuex.Store({
  state: {
    team: {
      id: parseInt(localStorage.getItem('teamId')),
      name: '',
    },
    game: {
      id: parseInt(localStorage.getItem('gameId')),
      name: '',
    },
    teams: [],
    tours: [],
    slides: {},
    currentSlide: {},

    currentSlideId: 0,
    timerStartTime: 0,
    lastSyncTime: 0,

    serverSettings: {
      mediaVolume: 100,
      mediaTv: true,
      tourAnswers: 0,
    },
  },
  getters: {
    game: state => state.game,
    team: state => state.team,
    tours: state => state.tours,
    slides: state => state.slides,

    currentSlideId: state => state.currentSlideId,
    timerStartTime: state => state.timerStartTime,
    resultsState: state => state.resultsState,
    lastSyncTime: state => state.lastSyncTime,

    currentSlide: state => state.currentSlide,
    serverSettings: state => state.serverSettings,
  },
  mutations: {
    setStatus(state, data) {
      const {
        sid = 0, t = 0, r = 0, ls = 0
      } = data;

      state.currentSlideId = sid;
      state.timerStartTime = t;
      state.resultsState = r;
      state.lastSyncTime = ls;

      state.currentSlide = state.slides[state.currentSlideId] || null;
    },
    setServerSettings(state, data) {
      state.serverSettings = data;
    },
    setGame(state, gameData) {
      const slides = {};
      gameData.slider.forEach((slide) => {
        slides[slide.id] = slide;
      });

      state.game = gameData.game;
      state.tours = gameData.tours;
      state.slides = slides;

      gameData.teams.forEach((team) => {
        if (team.team_id == state.team.id) {
          state.team = team;
          state.team.id = team.team_id;
        }
      });
    },
  },
  actions: {
    socket_state({ commit }, data) {
      if (data) {
        commit('setStatus', data);
      } else {
        alert('Состояние игры сброшено, перезапутите страницу');
      }
    },
    socket_settings({ commit, state }, data) {
      if (JSON.stringify(data) !== JSON.stringify(state.serverSettings)) {
        commit('setServerSettings', data);
      }
    },
    setGame({ commit }, gameData) {
      commit('setGame', gameData);
    },
    persissantDataFromStorageServer({ commit, state }) {
      if (state.game.id) {
        axios.get(`/game/${state.game.id}/settings`).then((result) => {
          commit('setServerSettings', result.data);
        });
      }
    }
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js